import React, { useState } from 'react';
import MenuGrid from './MenuGrid';
import { useTranslation } from 'react-i18next';

export default function MenuTabs() {
  const { i18n } = useTranslation();

  // Correct tab order: Appetizers first
  const sections = ['Appetizers', 'Sandwiches', 'Dishes', 'Drinks'];
  const [activeSection, setActiveSection] = useState(sections[0]); // Appetizers first

  // Simple inline translations for tabs
  const tabLabels = {
    Sandwiches: {
      en: 'Sandwiches',
      pl: 'Kanapki',
      ar: 'ساندويتشات',
    },
    Dishes: {
      en: 'Dishes',
      pl: 'Dania',
      ar: 'أطباق',
    },
    Appetizers: {
      en: 'Appetizers',
      pl: 'Przystawki',
      ar: 'المقبلات',
    },
    Drinks: {
    en: 'Drinks',
    pl: 'Napoje',
    ar: 'المشروبات',
  },
  };

  const isArabic = i18n.language === 'ar';

  return (
    <div className="max-w-[1200px] mx-auto">
      {/* Tabs */}
      <div
        className={`flex border-b mb-6 ${isArabic ? 'flex-row-reverse justify-end' : 'justify-start'}`}
        dir={isArabic ? 'rtl' : 'ltr'}
      >
        {sections.map((section) => (
          <button
            key={section}
            className={`px-4 py-2 font-bold text-2xl${
              activeSection === section
                ? 'border-b-8 border-red-600 text-red-600'
                : 'text-gray-600 hover:text-red-600'
            }`}
            onClick={() => setActiveSection(section)}
          >
            {tabLabels[section][i18n.language] || tabLabels[section].en}
          </button>
        ))}
      </div>

      {/* Menu Grid */}
      <MenuGrid section={activeSection} />
    </div>
  );
}
